import classNames from 'classnames'
import { forwardRef, useId } from 'react'
import { Icon } from '../Icon'
import TextInputWrapper from '../TextInputWrapper'
import styles from './Select.module.css'
import { SelectProps } from './types'

const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  {
    'id': id_,
    name,
    children,
    label,
    hint,
    required,
    disabled,
    disabled_,
    'aria-disabled': ariaDisabled_,
    description,
    error,
    warning,
    errorDisplay = 'all',
    fullWidth,
    wrapperClassName,
    ...props
  },
  ref
) {
  const generatedId = useId()
  const id = id_ || name || generatedId
  const inputDisabled = disabled_ || disabled
  const ariaDisabled = ariaDisabled_ || inputDisabled

  return (
    <TextInputWrapper
      label={label}
      name={name}
      description={description}
      error={error}
      warning={warning}
      id={id || name}
      required={required}
      errorDisplay={errorDisplay}
      fullWidth={fullWidth}
      hint={hint}
      className={wrapperClassName}
    >
      <div className={styles.selectContainer}>
        <select
          {...props}
          ref={ref}
          className={classNames(styles.select, {
            ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
            ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
          })}
          id={id}
          name={name}
          aria-disabled={ariaDisabled}
          disabled={disabled_}
        >
          {children}
        </select>
        <Icon name="chevronDown" />
      </div>
    </TextInputWrapper>
  )
})

export default Select
